import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 4h10l-10 16h10","key":"svg-0"}]]

const IconLetterZ = createReactComponent('outline', 'letter-z', 'LetterZ', __iconNode);

export default IconLetterZ;